import { track as sharedTrack } from '@fff-web/fff-analytics';
import collectCampaignInfoProperties from './analytic-collectors/collectCampaignInfoProperties';
import collectGenericInfoProperties from './analytic-collectors/collectGenericInfoProperties';

const MY_BOX_EXPERIENCE = 'My Box';

export const events = {
  CLICKED_ELEMENT: 'Clicked Element',
  START_CANCEL: 'start_cancel',
  CONFIRM_CANCEL: 'confirm_cancel',
  UPGRADE_STARTED: 'Upgrade Started',
  REACTIVATION_STARTED: 'Reactivation Started',
};

const EXPIRED_MEMBER_TRACKING = {
  type: 'Expired',
  reactivationType: 'Expired Member',
};

const track = (event, properties, options, callback) =>
  sharedTrack({
    trackName: event,
    properties: {
      ...properties,
      experience: MY_BOX_EXPERIENCE,
    },
    options,
    callback,
  });

export const trackRefillsCanceled = (user, replenishmentProducts, subscription, step) => {
  const event = 'Refills Cancelled';
  const genericProperties = collectGenericInfoProperties(user);
  const campaignProperties = replenishmentProducts?.campaignState
    ? collectCampaignInfoProperties({
        campaignData: replenishmentProducts.campaignState,
      })
    : {};

  const properties = {
    ...genericProperties,
    ...campaignProperties,
    product_id: subscription?.productId,
    product_name: subscription?.name,
    brand_name: subscription?.brand,
    sale_price: subscription?.price,
    refills_price: subscription?.replenishmentPrice,
    quantity: subscription?.quantity,
    step,
  };
  track(event, properties);
};

export const trackUpgradeStarted = (cta) => track(events.UPGRADE_STARTED, { cta_name: cta });

export const trackExpiredReactivateStarted = (cta) =>
  track(events.REACTIVATION_STARTED, {
    cta_name: cta,
    type: EXPIRED_MEMBER_TRACKING.type,
    reactivation_type: EXPIRED_MEMBER_TRACKING.reactivationType,
  });

export default {
  events,
  trackRefillsCanceled,
  track,
};
